import { render, staticRenderFns } from "./QuotationEmailModal.vue?vue&type=template&id=3828c9c2&scoped=true&"
import script from "./QuotationEmailModal.vue?vue&type=script&lang=ts&"
export * from "./QuotationEmailModal.vue?vue&type=script&lang=ts&"
import style0 from "./QuotationEmailModal.vue?vue&type=style&index=0&id=3828c9c2&lang=scss&scoped=true&"
import style1 from "./QuotationEmailModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3828c9c2",
  null
  
)

export default component.exports